import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import { FilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import { createAndCondition } from "@app/util/filters/utils";

const convertMapFilterModelToFilterModelForEntity = (
  entityType: EntityTypesSupportedByMapsPage,
  mapFilterModel: MapFilterModel
): FilterModel => {
  let result = mapFilterModel[entityType] ?? createAndCondition([]);
  if (mapFilterModel.universal) {
    // can't simply use result.conditions.push here otherwise that'll modify saved filter itself
    result = {
      ...result,
      conditions: [...result.conditions, { ...mapFilterModel.universal, tag: "universal" }],
    };
  }

  return result;
};

export default convertMapFilterModelToFilterModelForEntity;
